<template>
  <div>
    <div class="tariffs-title tariff-section-margin">{{ $t('packages.temporaryPasses.title') }}</div>
    <div class="tariffs-subtitle">{{ $t('packages.temporaryPasses.subtitle') }}</div>
    <div class="temporary-passes-list">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="temporary-pass"
        :class="{ 'temporary-pass-first': index === 0 }"
        @click="toggle(index)"
      >
        <div class="temporary-pass-row">
          <div class="temporary-pass-name">{{ item.name }}</div>
          <div class="temporary-pass-right">
            <span class="temporary-pass-price">{{ item.price }}</span>
            <img
              class="temporary-pass-chevron"
              :class="{ 'temporary-pass-chevron-open': opened[index] }"
              :src="chevron"
              alt=""
            />
          </div>
        </div>
        <div v-if="opened[index]" class="temporary-pass-description">
          {{ item.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chevron from '@/assets/svg/new/select-down.svg';

export default {
  name: "TemporaryPasses",
  data() {
    return {
      chevron,
      opened: {},
    };
  },
  computed: {
    items() {
      return [0, 1, 2, 3, 4].map((index) => ({
        name: this.$t(`packages.temporaryPasses.items[${index}].name`),
        price: this.$t(`packages.temporaryPasses.items[${index}].price`),
        description: this.$t(`packages.temporaryPasses.items[${index}].description`),
      }));
    },
  },
  methods: {
    toggle(index) {
      this.opened[index] = !this.opened[index];
    },
  },
}
</script>

<style scoped>

.tariffs-title {
  font-size: 28px;
  font-weight: bold;
}

@media screen and (min-width: 768px) {
  .tariffs-title {
    font-size: 32px;
  }
}

@media screen and (min-width: 1024px) {
  .tariffs-title {
    font-size: 40px;
  }
}

.tariffs-subtitle {
  white-space: pre-line;
  max-width: 1300px;
  font-size: 18px;
  color: #8a8a8a;
}

@media screen and (min-width: 768px) {
  .tariffs-subtitle {
    font-size: 22px;
  }
}

@media screen and (min-width: 1024px) {
  .tariffs-subtitle {
    font-size: 24px;
  }
}

.tariff-section-margin {
  margin-top: 40px;
}

@media screen and (min-width: 768px) {
  .tariff-section-margin {
    margin-top: 60px;
  }
}

@media screen and (min-width: 1024px) {
  .tariff-section-margin {
    margin-top: 80px;
  }
}

.temporary-passes-list {
  margin-top: 28px;
}

@media screen and (min-width: 768px) {
  .temporary-passes-list {
    margin-top: 42px;
  }
}

@media screen and (min-width: 1024px) {
  .temporary-passes-list {
    margin-top: 56px;
  }
}

.temporary-pass {
  border-bottom: 1px solid #000000;
  padding: 16px 0;
  cursor: pointer;
}

@media screen and (min-width: 768px) {
  .temporary-pass {
    padding: 24px 0;
  }
}

@media screen and (min-width: 1024px) {
  .temporary-pass {
    padding: 32px 0;
  }
}

.temporary-pass-first {
  border-top: 1px solid #000000;
}

.temporary-pass-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.temporary-pass-name {
  font-size: 18px;
}

@media screen and (min-width: 768px) {
  .temporary-pass-name {
    font-size: 22px;
  }
}

@media screen and (min-width: 1024px) {
  .temporary-pass-name {
    font-size: 24px;
  }
}

.temporary-pass-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.temporary-pass-price {
  font-size: 18px;
  font-weight: bold;
}

@media screen and (min-width: 768px) {
  .temporary-pass-price {
    font-size: 22px;
  }
}

@media screen and (min-width: 1024px) {
  .temporary-pass-price {
    font-size: 24px;
  }
}

.temporary-pass-chevron {
  width: 24px;
  height: 24px;
  transition: transform 0.2s ease;
}

.temporary-pass-chevron-open {
  transform: rotate(180deg);
}

.temporary-pass-description {
  margin-top: 12px;
  font-size: 16px;
  line-height: 1.5;
  color: #8a8a8a;
}

@media screen and (min-width: 768px) {
  .temporary-pass-description {
    margin-top: 16px;
    font-size: 18px;
  }
}

@media screen and (min-width: 1024px) {
  .temporary-pass-description {
    font-size: 20px;
  }
}

</style>
